import React from 'react';
import { styled } from 'styled-components';
import { Colors, hexToRGB } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EpisodeAttribute = ({
  icon,
  text,
  label
}) => /*#__PURE__*/_jsxs(Attribute, {
  children: [icon && /*#__PURE__*/_jsx(Icon, {
    children: icon
  }), text && /*#__PURE__*/_jsx(Text, {
    children: text
  }), /*#__PURE__*/_jsx("span", {
    children: label
  })]
});
const Attribute = styled.div.withConfig({
  displayName: "EpisodeAttribute__Attribute",
  componentId: "sc-1l00ius-0"
})(["display:grid;grid-gap:12px;grid-auto-flow:column;align-items:center;margin-top:12px;margin-right:32px;", "{margin-right:12px;}"], Viewports.for('small'));
const Icon = styled.div.withConfig({
  displayName: "EpisodeAttribute__Icon",
  componentId: "sc-1l00ius-1"
})(["color:", ";background-color:", ";border-radius:4px;margin-right:2px;font-size:24px;display:flex;align-items:center;justify-content:center;"], Colors.GREY_2c2c2c, hexToRGB(Colors.WHITE, 0.6));
const Text = styled.div.withConfig({
  displayName: "EpisodeAttribute__Text",
  componentId: "sc-1l00ius-2"
})(["", ";color:", ";text-align:center;border-radius:4px;background-color:", ";padding:4px;"], Fonts.medium(14), Colors.GREY_2c2c2c, hexToRGB(Colors.WHITE, 0.6));